import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { descriptionMarkdownComponents } from './EntityDetailDrawer';

/**
 * A drawer's description, folded behind a disclosure.
 *
 * For a drawer whose point is something else — a workflow's runs — and whose
 * card already shows the description's opening lines. Rendered with the
 * drawer's own markdown styles, so unfolded it reads exactly as it would have.
 */
const DrawerAboutSection: React.FC<{ description: string; label?: string }> = ({
    description, label = 'About this workflow'
}) => {
    const [open, setOpen] = useState(false);
    if (!description.trim()) return null;
    return (
        <section className="mt-5 pt-3 border-t border-line">
            <button
                onClick={() => setOpen((value) => !value)}
                aria-expanded={open}
                className="bg-transparent border-none p-0 m-0 mb-2 cursor-pointer flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-fg-2 hover:text-accent-fg transition-colors"
            >
                <ExpandMoreIcon
                    style={{ fontSize: 18, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s ease' }}
                />
                {label}
            </button>
            {open && (
                <ReactMarkdown remarkPlugins={[remarkGfm]} components={descriptionMarkdownComponents}>
                    {description}
                </ReactMarkdown>
            )}
        </section>
    );
};

export default DrawerAboutSection;
